import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
// import Header from '../../layout/header/Header';
import { selectAllTimeSlot3d } from '../../../redux/3d_game_Slice/gameinfo3d';
// import { setLoaderShow } from '../../redux/slice/seriesSlice';
// import { selectSocket } from '../../redux/slice/socketSlice';
// import {socket} from '../../socket/Socket';
import { SocketState } from '../../../context/SocketProvider';
import "./resultPopUp.scss";
import ModalContainer from '../../../2d-game/modals/ModalContainer';

function ReprintPopUp3d(props) {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const { socket } = SocketState()

  let { time } = useParams();
  let allTimeSlot = useSelector(selectAllTimeSlot3d);
  useEffect(() => {
    // dispatch(setLoaderShow(true))
    var data = {
      en: "PICK_THREE_GET_BET_LISTS",
      data: {},
    };
    socket.emit("req", data);
  }, [])

  // useEffect(() => {
  //   document.body.style.overflow = 'hidden';
  //   return () => {
  //     document.body.style.overflow = 'unset';
  //   }
  // }, [])

  // let getTicketsList = (time) => () => {

  //   let data = {
  //     "en": "PICK_THREE_GET_BET_LISTS",
  //     "data": {
  //       "time": time
  //     }
  //   }
  //   socket.emit("req", data);
  //   // dispatch(setLoaderShow(true))
  //   navigate(time)
  // }

  return (
    <>
      {/* <Outlet /> */}
      <ModalContainer title={'RePrint'}navigation={'/3d'}>
        <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-20vh)] overflow-y-auto'>
          {/* {allTimeSlot?.map((time, index) => {
            return (
              <div className='w-1/6 px-1 py-1.5' key={index}>
                <div className={`border-2 py-3 rounded-lg border-gray-300 flex items-center justify-center cursor-pointer hover:bg-[#e54859] hover:text-white ${time.disable ? 'bg-gray-400' : 'bg-[#fff]'}`}
                  onClick={getTicketsList(time.time)}
                >
                  <p className='font-semibold text-[17px] hover:text-white'>{time.time}</p>
                </div>
              </div>
            )
          })} */}
        </div>
      </ModalContainer>
      {/* <Outlet />

      {!time &&
        <div
          className="modal fade show block"
          id="kt_modal_add_user"
          role="dialog"
          tabIndex={-1}
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl" style={{ margin: "0", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
            <div className="modal-content relative" style={{ minHeight: "100%", height: "100%", width: "100%", overflow: "unset", background: "transparent" }}>
              <button type="button" aria-label="Close" className="btn-close" onClick={() => {
                navigate(`/3d`);
              }} style={{
                position: 'absolute',
                right: '10px',
                top: '8px',
                height: '20px',
                width: '20px',
                backgroundColor: '#47fff3',
                color: '#fff',
                opacity: 1,
                fontSize: '14px',
                borderRadius: '6px',
                filter: 'invert(1)',
                boxShadow: 'none',
              }}></button>
              <div className='black-section pb-0' style={{ paddingBottom: "0", height: "100%" }}>
                <div className='popup-inner'>
                  <div className='flex flex-wrap'>
                    {allTimeSlot?.map((time, index) => {
                      return <div className='box-inner-checkbox' key={index}>
                        <div className='font-bold flex align-items-center pointer' onClick={getTicketsList(time.time)}>
                          {time.time}
                        </div>
                      </div>
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      } */}
    </>
  )
}

export default ReprintPopUp3d